import addEvents from "./add";
import updateEvents from "./update";

export default {
    ...addEvents,
    ...updateEvents,
};

